import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";
import {
  IDespacho,
  Informativo,
  IPorSeleccion,
  VoBo,
} from "../../interfaces/despacho";

export const selectDespachoState = (state: AppState) => state.formaEnvio;
export const selectDespacho = (state: AppState) => state.formaEnvio;
export const selectFormasEnvioContador = createSelector(
  selectDespachoState,
  (state) => state.contador
);

export const selectDespachosTodos = createSelector(
  selectDespachoState,
  (state) => {
    return state.despachos;
  }
);

export const selectTipoDespachoExpandido = createSelector(
  selectDespachoState,
  (state) => {
    return state.currentExpanded;
  }
);

export const selectDespachosInformativo = createSelector(
  selectDespachosTodos,
  (despachos) => {
    const info = despachos.filter(
      (despacho: IDespacho) =>
        despacho?.Informativo && despacho.Informativo.length > 0
    );
    console.log("Informativo", info);

    return info;
  }
);

export const selectDespachosVoBo = createSelector(
  selectDespachosTodos,
  (despachos) => {
    const vobo = despachos.filter(
      (despacho) => despacho?.VoBo && despacho.VoBo.length > 0
    );
    console.log("vobo", vobo);

    return vobo;
  }
);

export const selectDespachosEmpresas = createSelector(
  selectDespachoState,
  (state) => {
    if (!state.despachos) {
      return [];
    }
    return state.despachos.map((despacho) => {
      return {
        descripcion: despacho.nombre_empresa,
        id: despacho.id_empresa,
        id_empresa: despacho.id_empresa,
      };
    });
  }
);

export const selectCatEmpresas = createSelector(
  selectDespachoState,
  (state) => {
    if (!state.despachos) {
      return [];
    }
    const cat = state.despachos.map((despacho) => {
      return {
        descripcion: despacho.nombre_empresa,
        id: despacho.id_empresa,
        id_empresa: despacho.id_empresa,
        disabled: false,
      };
    });

    return [
      {
        descripcion: "Seleccione una empresa.",
        id: "",
        id_empresa: "",
        disabled: true,
      },
      ...cat,
    ];
  }
);

export const selectDespachoActual = createSelector(
  selectDespachoState,
  (state) => state.despacho
);

export const selectDespachoEntradas = createSelector(
  selectDespachoState,
  (state) => state.entradas
);

export const selectSaveDespacho = createSelector(
  selectDespachoState,
  (state) => state.form
);
export const selectEsNuevoDespacho = createSelector(
  selectDespachoState,
  (state) => state.nuevoDespacho
);
export const selectGuardandoDespacho = createSelector(
  selectDespachoState,
  (state) => state.guardando
);

export const selectStatusDespacho = createSelector(
  selectDespachoState,
  (state) => state.status
);

export const selectTemasVoBoInformativo = createSelector(
  selectDespachoState,
  (state) => {
    const temas = [...state.despacho.Informativo, ...state.despacho.VoBo];

    return temas.map((tema) => {
      return {
        ...tema,
        indiceTema: tema.indice,
        indice_tema: tema.indice,
        searchText: "",
        selectedItem: false,
      };
    });
  }
);

export const selectTemasANotificar = (nombreUsuario: string) =>
  createSelector(selectDespachoState, (state) => {
    const temas = [...state.despacho.Informativo, ...state.despacho.VoBo];
    return temas.map((tema) => {
      return {
        nombreUsuario,
        empresa: tema.nombre_empresa,
        tipoDespacho: tema.descripcion,
        nombreTema: tema.nombreTema,
        descripcionTema: tema.descripcionTema,
        id_empresa: tema.id_empresa,
        notificacion: "nuevoTema",
      };
    });
  });

export const selectCamposValidosTemas = createSelector(
  selectDespachoState,
  (state) => {
    const temas = [...state.despacho.Informativo, ...state.despacho.VoBo];

    const allCamposValidos = temas.every(
      (tema) => tema.nombreTema && tema.nombreTema.trim() !== ""
    );
    return allCamposValidos;
  }
);

export const selectTemasParaImpresion = createSelector(
  selectDespachoState,
  (state) => {
    const toPrint = state.despachos.flatMap((despacho: IDespacho) => [
      ...despacho.VoBo.filter((vobo: VoBo) => vobo?.marcarParaImpresion).map(
        (vobo: VoBo) => ({
          nombreTema: vobo.nombreTema,
          nombre_empresa: despacho.nombre_empresa,
          tipo_despacho: "VoBo",
        })
      ),
      ...despacho.Informativo.filter(
        (info: Informativo) => info?.marcarParaImpresion
      ).map((info: Informativo) => ({
        nombreTema: info.nombreTema,
        nombre_empresa: despacho.nombre_empresa,
        tipo_despacho: "Informativo",
      })),
    ]);
    const data: IPorSeleccion = {
      toPrint: [...toPrint],
    };
    return data;
  }
);
